import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-impressum',
  templateUrl: './impressum.component.html',
  styles: []
})
export class ImpressumComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
